import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import React from "react";
import "./CommonPagination.css";

interface Props {
  count: number;
  handleChangePage: (event: any, value: number) => void;
  rowPerPage: number;
  handleChangeCount: (e: any) => void;
  page: number;
}

const CommonPagination = ({
  count,
  handleChangePage,
  rowPerPage,
  handleChangeCount,
  page,
}: Props) => {
  return (
    <div className="paginations mt-3 float-right d-flex">
      <Pagination
        count={count}
        page={page}
        onChange={handleChangePage}
        color="primary"
        shape="rounded"
      />
      <FormControl className="">
        <Select
          className="multipleSelectPage"
          value={rowPerPage}
          name="rowPerPage"
          onChange={handleChangeCount}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default CommonPagination;
